import { render, staticRenderFns } from "./SubFormConfig.vue?vue&type=template&id=712f2e99"
import script from "./SubFormConfig.vue?vue&type=script&lang=js"
export * from "./SubFormConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports